export const SATHI_MODAL_STEPS = {
  CLOSED: 'closed',
  NON_GAP_CONNECT: 'non_gap_connect',
  GAP_CONNECT: 'gap_connect',
  GENERATE_API_KEY: 'generate_api_key',
  ENTER_API_KEY: 'enter_api_key',
  CONNECTION_SUCCESS: 'connection_success',
  SUPPORT: 'support',
  MIGRATION_IN_PROGRESS: 'migration_in_progress',
  MIGRATION_INTERRUPTED: 'migration_interrupted',
} as const;

export const SATHI_MIGRATION_STATUS = {
  MIGRATED: 'migrated',
  IN_PROGRESS: 'in_progress',
  NOT_STARTED: 'not_started',
  FAILED: 'failed',
} as const;

export const SATHI_APP_URL = 'https://app.mysathi.io';

export const SATHI_INVALID_API_KEY_ERROR = "That doesn't look like a SATHI key!";

export const GENERATE_SATHI_API_KEY_STEPS = [
  `<p>Log in to <strong><a href="${SATHI_APP_URL}" target="_blank" rel="noopener noreferrer">SATHI</a></strong></p>`,
  '<p>Go to <strong>Settings</strong> → <strong>Integrations</strong></p>',
  '<p>From the SARAL card, click <strong>"Connect"</strong></p>',
  '<p>Click <strong>Generate API key</strong> in the modal</p>',
  '<p>Copy the key and paste it in the next step</p>',
] as const;

export const CONNECT_SATHI_FROM_GAP_STEPS = [
  {
    icon: '🔌',
    title: 'Shopify + GoAffPro will be disconnected',
    description:
      'Your current GAP integration will stop working for this store. You can uninstall GAP after this is done.',
  },
  {
    icon: '🔗',
    title: 'Affiliate operations powered by SATHI',
    description: 'The back-end changes. You continue generating links or codes, shipping product, etc. through SARAL.',
  },
  {
    icon: '👥',
    title: 'Existing affiliates will be migrated',
    description:
      'Your affiliates from GoAffPro will be automatically imported into SATHI. Their links/codes remain the same.',
  },
] as const;
